import { Pipe, PipeTransform } from '@angular/core';
import { DisplayStageNatureTypeDto } from '../../beneficiaries/beneficiary-folder/stages/display-stage-nature-type.dto';

@Pipe({
  name: 'uniqueNature',
  standalone: false,
})
export class UniqueNaturePipe implements PipeTransform {
  transform(stageNatureTypes: DisplayStageNatureTypeDto[]): string[] | undefined {
    if (stageNatureTypes) {
      const natures: string[] = stageNatureTypes.map((type: DisplayStageNatureTypeDto) => type.nature);
      return Array.from(new Set(natures)).sort((a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    }
  }
}
